// extracted by mini-css-extract-plugin
export default {"toggle-button":"styles_toggle-button__+1e2N","selected":"styles_selected__q3DRF"};